let list = [
  {
    path: '/user',
    component: () => import('@/views/c_main/home/index'),
    redirect: '/user/index',
    children: [
      {
        path: 'index',
        name: 'home',
        component: () => import('@/views/c_main/home/home'),
        meta: {
          keepAlive: true,
          title: '营销案例'
        }
      },
      {
        path: 'course',
        name: 'course',
        component: () => import('@/views/c_main/course'),
        meta: {
          keepAlive: true,
          title: '精品课程'
        }
      },
      {
        path: 'my',
        name: 'my',
        component: () => import('@/views/c_main/home/my'),
        meta: {
          title: '我的'
        }
      }
    ]
  },
  {
    path: '/course',
    name: 'course',
    component: () => import('@/views/c_main/course'),
    meta: {
      title: '课程列表'
    }
  },
  {
    path: '/courseDetails',
    name: 'courseDetails',
    component: () => import('@/views/c_main/courseDetails'),
    meta: {
      title: '课程详情'
    }
  },
  {
    path: '/c_articleDetails',
    name: 'c_articleDetails',
    component: () => import('@/views/c_main/articlePage/c_articleDetails'),
    meta: {
      title: ''
    }
  },
  {
    path: '/c_resource',
    name: 'resourcePool',
    component: () => import('@/views/c_main/resourcePool/resourcePool'),
    meta: {
      keepAlive: true,
      title: '我的资源库'
    }
  },

  {
    path: '/searchResource',
    name: 'searchResource',
    component: () => import('@/views/c_main/resourcePool/searchResource'),
    meta: {
      title: '搜索'
    }
  },

  {
    path: '/c_purchase',
    name: 'c_purchase',
    component: () => import('@/views/c_main/c_purchase/c_purchase'),
    meta: {
      title: '购买记录'
    }
  },
  {
    path:"/head",
    meta: {
      title: '头像裁切'
    },
    component: () => import('@/views/myCenter/head'),

  },
  {
    path: '/c_featuredArticleLists',
    name: 'c_featuredArticleLists',
    component: () =>
      import('@/views/c_main/articlePage/c_featuredArticleLists'),
    meta: {
      title: '精选文章'
    }
  },
  {
    path: '/c_setting',
    name: 'c_setting',
    component: () => import('@/views/c_main/myCenter/c-setting')
  },
  {
    path: '/c_cashierDesk',
    name: 'c_cashierDesk',
    component: () => import('@/views/c_main/c_cashierDesk'),
    meta: {
      title: '收银台'
    }
  },
  {
    path: '/c_videoDetails',
    name: 'c_videoDetails',
    component: () => import('@/views/c_main/articlePage/c_videoDetails'),
    meta: {
      title: '视频详情'
    }
  },
  {
    path: '/merchantRegistration',
    name: 'merchantRegistration',
    component: () => import('@/views/c_main/merchantRegistration'),
    meta: {
      keepAlive: true,
      title: '商家注册详情'
    }
  },
  {
    path: '/agree',
    name: 'agree',
    component: () => import('@/views/c_main/agree'),
    meta: {
      title: '协议'
    }
  },
  {
    path: '/registerSuccess',
    name: 'registerSuccess',
    component: () => import('@/views/c_main/registerSuccess'),
    meta: {
      title: '我的企叮咚'
    }
  },
  {
    path: '/successOrder',
    name: 'successOrder',
    component: () => import('@/views/c_main/successOrder'),
    meta: {
      title: '支付成功'
    }
  },
  {
    path: '/c_mykecheng',
    name: 'c_mykecheng',
    component: () => import('@/views/c_main/myCenter/c_mykecheng'),
    meta: {
      title: '我的课程列表'
    }
  },{
    path: '/authMember',
    name: 'authMember',
    component: () => import('@/views/fenyong/authMember'),
    meta: {
      title: '认证信息'
    }
  },{
    path: '/authMemberBank',
    name: 'authMemberBank',
    component: () => import('@/views/fenyong/authMemberBank'),
    meta: {
      title: '绑定银行卡'
    }
  },
  {
    path: '/clientDetailsUser',
    name: 'clientDetails',
    component: () => import('@/views/c_main/myCenter/clientDetails'),
    meta: {
      title: '客户详情'
    }
  },
  {
    path: '/storeRegister',
    name: 'storeRegister',
    component: () => import('@/views/c_main/register/storeRegister'),
    meta: {
      keepAlive: true,
      title: '商家注册详情'
    }

  },
  {
    path: '/effect',
    name: 'effect',
    component: () => import('@/views/c_main/register/effect'),
    meta: {
      title: '开通账户'
    }
  },
  {
	  path: '/buyTicket',
	  name: 'buyTicket',
	  meta: {
	    title: '购买门票', //门票详情路由 c
	  },
	  component: () => import('@/views/c_main/ticket/details')
	},
  {
	  path: '/TicketList',
	  name: 'TicketList',
	  meta: {
	    title: '我的门票', //我的门票 c
	  },
	  component: () => import('@/views/c_main/ticket/TicketList')
	},{
    path: '/c_mykechengcode',
    name: 'c_mykechengcode',
    component: () => import('@/views/c_main/myCenter/c_mykechengcode'),
    meta: {
      title: '课程兑换码'
    }
  },{
    path: '/c_scancode',
    name: 'c_scancode',
    component: () => import('@/views/c_main/myCenter/c_scancode'),
    meta: {
      title: '课程兑换码'
    }
  },
]

export default {
  list
}
